import { Reveal } from "../components/Reveal";
import { Pillars } from "../sections/Pillars";
import { Why } from "../sections/Why";
import { Philosophy } from "../sections/Philosophy";
import { Community } from "../sections/Community";

export default function UeberPage() {
  return (
    <main className="pt-28" data-testid="ueber-page">
      <section className="py-14 sm:py-20 text-center">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Reveal>
            <p className="eyebrow-label mb-5">Über VisualMA</p>
            <h1 className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.06] mb-6">
              Lernen darf <em style={{ color: "var(--terra)" }}>schön</em> sein.
            </h1>
            <p className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed max-w-xl mx-auto">
              VisualMA ist ein junges Lernlabel für Kinder ab 2 Jahren. Wir gestalten kleine
              Lernwelten, die visuelles Lernen, einfache Sprache und Musik miteinander verbinden –
              für gemeinsame Momente von Kindern und ihren Bezugspersonen.
            </p>
          </Reveal>
        </div>
      </section>
      <Philosophy />
      <Why />
      <Pillars />
      <Community />
    </main>
  );
}
